import * as THREE from "three"
import Experience from "../Experience.js";

export default class Environment {

    constructor() {

        this.experience = new Experience()
        this.scene = this.experience.scene
        this.debug = this.experience.debug


        // Debug
        if (this.debug.active) {

            this.debugFolder = this.debug.gui.addFolder("Lights")
        }


        // Adjusted intensities to match previous brightness (Color 255 * 0.1 => 25.5)
        this.pointLight1 = new THREE.PointLight(0xffffff, 14, 5.0, 1.3)
        this.pointLight1.position.set(-2, -0.95, 3)
        this.pointLight2 = new THREE.PointLight(0xffffff, 16, 5.0)
        this.pointLight2.position.set(2, 2, -3)
        this.pointLight3 = new THREE.PointLight(0xffffff, 32, 5.0)
        this.pointLight3.position.set(2, 1.14, 0.3)
        this.pointLight4 = new THREE.PointLight(0xffffff, 1.5, 5.0)
        this.pointLight4.position.set(-0.95, -0.3, 3.36)
        this.pointLight5 = new THREE.PointLight(0xffffff, 45.7, 5.0, 0)
        this.pointLight5.position.set(-0.95, 1.4, 0.22)
        this.pointLight6 = new THREE.PointLight(0xffffff, 7.2, 5.0, 2.076)
        this.pointLight6.position.set(0.88, -0.82, 2.57)
        this.pointLight7 = new THREE.PointLight(0xffffff, 50, 5.0, 2.413)
        this.pointLight7.position.set(3.04, -1.53, -2.57)


        // Directional Lights
        this.directionalLight = new THREE.DirectionalLight(0xffffff, 10, 5.0, 1.0)
        this.directionalLight1 = new THREE.DirectionalLight(0xffffff, 10, 5.0, 1.0)
        this.directionalLight.position.set(0, 3, 3)
        this.directionalLight1.position.set(0, 5, 0)
        this.directionalLight.lookAt(new THREE.Vector3(0, 0, 0))
        this.directionalLight1.lookAt(new THREE.Vector3(0, 0, 0))
        this.scene.add(this.directionalLight, this.directionalLight1)

        this.directionalLightHelper = new THREE.DirectionalLightHelper(this.directionalLight)
        // this.scene.add(this.directionalLightHelper)

        // this.pointLightHelper = new THREE.pointLightHelper(this.pointLight)

        this.scene.add(this.pointLight1)
        this.scene.add(this.pointLight2)
        this.scene.add(this.pointLight3)
        this.scene.add(this.pointLight4)
        this.scene.add(this.pointLight5)
        this.scene.add(this.pointLight6)
        this.scene.add(this.pointLight7)
        // this.scene.add(this.pointLightHelper)


        // Debug
        this.debugLights()

    }

    debugLights() {
        if (this.debug.active) {

            this.debugParams = {
                selectedLight: "pointLight1"
            }

            this.debugObject = {
                color: "#ffffff"
            }

            this.lightsMap = {
                pointLight1: this.pointLight1,
                pointLight2: this.pointLight2,
                pointLight3: this.pointLight3,
                pointLight4: this.pointLight4,
                pointLight5: this.pointLight5,
                pointLight6: this.pointLight6,
                pointLight7: this.pointLight7,
            }

            // Function to update controls
            this.updateDebugInputs = () => {
                // If folder exists, destroy it control the old controls
                if (this.positionFolder) this.positionFolder.destroy()

                this.positionFolder = this.debugFolder.addFolder("Position")

                // Get the light object based on the string key
                const currentLight = this.lightsMap[this.debugParams.selectedLight]

                if (currentLight) {
                    // this.debugObject.color = "#" + currentLight.color.getHexString()

                    this.positionFolder.add(currentLight.position, 'x').min(-5).max(5).step(0.01)
                    this.positionFolder.add(currentLight.position, 'y').min(-5).max(5).step(0.01)
                    this.positionFolder.add(currentLight.position, 'z').min(-5).max(5).step(0.01)
                    this.positionFolder.add(currentLight, 'intensity').min(0).max(50).step(0.1)
                    this.positionFolder.add(currentLight, 'decay').min(0).max(3).step(0.001)
                    this.positionFolder.addColor(this.debugObject, "color").onChange((value) => {
                        currentLight.color.set(value)
                    })
                }
            }

            // Dropdown
            this.debugFolder.add(this.debugParams, 'selectedLight', Object.keys(this.lightsMap))
                .onChange(() => {
                    this.updateDebugInputs()
                })

            // Initialize
            this.updateDebugInputs()
        }
    }
}